import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  Space,
  Form,
  Button,
  notification,
  message,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import userRequest from "../UserRequest";
import roleRequest from "../RoleRequest";
import { Option } from "antd/es/mentions";

export const UpdateUser = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get userId from URL params
  const [roleList, setRoleList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [showVendorDropdown, setShowVendorDropdown] = useState(false);
  const [userData, setUserData] = useState(null);

  const fetchRoleList = () => {
    setLoading(true);
    roleRequest
      .roleList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setRoleList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch role list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchVendorList = () => {
    setLoading(true);
    userRequest
      .vendorList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setVendorList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch vendor list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchUserData = () => {
    setLoading(true);
    userRequest
      .getUserById(id)
      .then((response) => {
        const data = response?.data?.data || {};
        console.log(data);
        setUserData(data);
        form.setFieldsValue({
          ...data, // Populate the form fields with fetched data
        });

        // Show Vendor dropdown if the role is 3 (vendor)
        setShowVendorDropdown(data.roleId === 3);
      })
      .catch((error) => {
        message.error("Failed to fetch user data");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    setLoading(true);
    const updatedUserData = { ...values };
    userRequest
      .updateUser(id, updatedUserData)
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "User updated successfully",
          });
          navigate(-1); // Go back after success
        } else {
          notification.error({
            message: "Failed to update user",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to update user",
        });
      });
  };

  const handleChange = (value, name) => {
    if (name === "roleId") {
      setShowVendorDropdown(value === 3);
    }

    if (name === "firstName" || name === "lastName") {
      const firstName = form.getFieldValue("firstName");
      const lastName = form.getFieldValue("lastName");
      form.setFieldsValue({
        fullName: `${firstName} ${lastName}`,
      });
    }
  };

  useEffect(() => {
    fetchRoleList();
    fetchVendorList();
    fetchUserData(); // Fetch user data on component mount
  }, [id]);

  return (
    <section>
      <div className="Create-Category">
        <Form.Item className="text-center submit-btn">
          <Space>
            <Button
              className="f-sub-btn btn-width"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              <ArrowLeftOutlined />
            </Button>
          </Space>
        </Form.Item>
        <h3>Update User</h3>

        {/* Add Ant Design Form component and pass the form instance */}
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <div className="subscription">
            <Form.Item
              name="firstName"
              label="First Name"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the first name!" },
                {
                  pattern: /^[A-Za-z\s]+$/,
                  message: "First name can only contain alphabetic characters!",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter First Name"
                onChange={(e) => handleChange(e.target.value, "firstName")}
              />
            </Form.Item>

            <Form.Item
              name="lastName"
              label="Last Name"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the last name!" },
                {
                  pattern: /^[A-Za-z\s]+$/,
                  message: "Last name can only contain alphabetic characters!",
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter Last Name"
                onChange={(e) => handleChange(e.target.value, "lastName")}
              />
            </Form.Item>

            <Form.Item
              name="fullName"
              label="Full Name"
              className="subscription-plan"
            >
              <Input size="large" disabled />
            </Form.Item>
          </div>

          <div className="subscription">
            <Form.Item
              name="email"
              label="Email"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input size="large" placeholder="Enter User Email" />
            </Form.Item>
            <Form.Item
              name="mobile"
              label="Phone No"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the Phone No!" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Phone No must be exactly 10 digits!",
                },
              ]}
            >
              <Input size="large" placeholder="Enter Phone No" />
            </Form.Item>
          </div>

          <div className="subscription">
            <Form.Item
              name="userName"
              label="User Name"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the user name!" },
              ]}
            >
              <Input size="large" placeholder="Enter User Name" />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              className="subscription-plan"
              rules={[
                { required: true, message: "Please enter the password!" },
              ]}
            >
              <Input size="large" placeholder="Enter password" />
            </Form.Item>
          </div>

          <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save
                <span>
                  <AiOutlineRight />
                </span>
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};
